import { PanelType } from '../../../../../../panels/types';
import { CriteriaPanelData } from '../../base-criteria-plugin-panel/ConnectedBaseCriteriaPanel';

export const meddpiccPanelType: PanelType<CriteriaPanelData> = {
  name: 'MEDDPICC_PANEL',
  location: 'left'
};
